import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ThemesTabLoader from "./themes-tab-loader";
import { updateColours } from "@Shared/@Utils/utils";
import { removeColours } from "@Shared/utils/helpers/theme";
import UploadLogo from "./upload-logo";
import Theme from "./theme";
import OverrideCustomizations from "../../override-customizations";
import { UPDATE_NAV_LOGO } from "../../store/settings-actions";
import { SET_STYLES } from "@Broker/@Modules/main/store/account/account-mutations";
import { LOAD_STYLES } from "@Broker/@Modules/main/store/account/account-actions";
import { mapActions, mapState, mapMutations } from "vuex";
import { S3_BUCKET_URL } from "@Shared/@Utils/constants";
import { loadCSS, getCurrentColor } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ThemesTab",
  components: {
    OverrideCustomizations,
    UploadLogo,
    Theme,
    ThemesTabLoader
  },
  props: {
    saving: {
      type: Boolean,
      required: true
    },
    settingsType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      logo: "",
      loading: true,
      formChanged: false,
      currentThemeObject: {}
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("SettingsStore", ["brokerageData", "overrides", "isOnThemePreviewMode"])), mapState("AccountStore", ["accountDetails", "styles"])), {}, {
    isBrokerageSettings() {
      return this.settingsType === "brokerage-settings";
    },
    isPersonalSettings() {
      return this.settingsType === "personal-settings";
    },
    brokerageSubdomain() {
      return this.brokerageData.subdomain;
    },
    personalSubdomain() {
      return this.accountDetails.accountSubdomain;
    },
    subdomainToUse() {
      return this.isBrokerageSettings ? this.brokerageSubdomain : this.personalSubdomain;
    }
  }),
  mounted() {
    this.loadData();
  },
  destroyed() {
    if (this.isOnThemePreviewMode) return;
    if (this.isBrokerageSettings || this.formChanged) this.revertStyles();
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [UPDATE_NAV_LOGO])), mapMutations("AccountStore", [SET_STYLES])), mapActions("AccountStore", [LOAD_STYLES])), {}, {
    revertStyles() {
      updateColours(this.styles.primary, this.styles.secondary);
    },
    async loadData() {
      const time = new Date().getTime();
      this.logo = this.isPersonalSettings ? this.$options.filters.getLogo(this.subdomainToUse) : `${S3_BUCKET_URL}/portal-styles/${this.subdomainToUse}?${time}`;
      this.loadProperStyles();
    },
    handleAllowSave(value) {
      this.$emit("allow-save", value);
    },
    handleFinishSaving(value) {
      this.$emit("finish-saving", value);
    },
    loadProperStyles() {
      const link = loadCSS(this.subdomainToUse, true);
      link.onload = () => {
        removeColours();
        this.currentThemeObject = getCurrentColor();
        updateColours(this.currentThemeObject.primary, this.currentThemeObject.secondary);
        this.loading = false;
      };
    },
    loadStyles() {
      this.LOAD_STYLES();
    },
    handleChangeLogo(logo) {
      this.logo = logo;
    },
    handleUpdateOverride() {
      this.UPDATE_NAV_LOGO({
        domain: this.personalSubdomain
      });
      if (this.overrides.overrideStyle) {
        this.loadStyles();
      } else {
        const link = loadCSS(this.personalSubdomain, true);
        link.onload = () => {
          removeColours();
          this.loadStyles();
        };
      }
    },
    handleFormChange(change) {
      this.formChanged = change;
    }
  })
});